export default {
  getRootId: (state) => state.teamsTree[0].uuid,
};
